export default "__VITE_ASSET__ByqtWssi__"